module.exports = __webpack_public_path__ + "img/galery18.f6b32ad0.jpg";